import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LightRays from "./LightRays";
import Header from "./Header";
import logo from "../assets/1.png";
import "./Login.css";

export default function AdminLogin() {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await fetch(
        "https://hrms.urbango.co.in/server/index.php?endpoint=admin-login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: loginId, password }),
        }
      );
      const data = await res.json();
      if (data.success) {
        localStorage.setItem("admin", JSON.stringify(data.admin));
        localStorage.setItem("role", "admin");
        navigate("/admin-dashboard", { replace: true });
      } else {
        setError(data.message || "Invalid username/orgId or password.");
      }
    } catch (err) {
      setError("Server error. Please try again.");
    }
  };

  return (
    <>
      <Header />
      {/* Animated Background */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 0,
          width: "100vw",
          height: "100vh",
          pointerEvents: "none",
          overflow: "hidden",
          background:
            "linear-gradient(135deg, rgba(255,100,180,0.15) 0%, rgba(120,0,255,0.1) 70%)",
        }}
      >
        <LightRays
          raysOrigin="top-center"
          raysColor="rgba(255, 17, 0, 0.7)"
          raysSpeed={1.5}
          lightSpread={0.8}
          rayLength={1.2}
          followMouse={true}
          mouseInfluence={0.1}
          noiseAmount={0.1}
          distortion={0.05}
          className="custom-rays"
        />
      </div>

      <div className="lg-login-root">
        <div className="lg-login-shell" style={{ zIndex: 1 }}>
          {/* LEFT PANEL */}
          <section className="lg-left glass hover-reflect">
            <div className="lg-left-inner">
              <h1 className="lg-hero-title">Admin Console</h1>
              <div className="lg-rotator-wrap">
                <div className="role-container">
                  <span className="role">Access Control</span>
                  <span className="role">User Management</span>
                  <span className="role">System Settings</span>
                  <span className="role">Leave Balance</span>
                  <span className="role">Login Tracker</span>
                </div>
                <p className="lg-hero-sub">
                  Manage employees, leave, and announcements with full administrative control and security.
                </p>
              </div>
            </div>
          </section>

          {/* RIGHT LOGIN BOX */}
          <section className="lg-right">
            <div className="login-form-wrapper glass hover-reflect">
              <img src={logo} alt="Urbango Logo" className="login-logo" />
              <h2 className="login-title">Admin Login</h2>
              <form
                onSubmit={handleSubmit}
                className="login-form"
                autoComplete="off"
              >
                {/* Username or Org ID input */}
                <input
                  className="login-input"
                  placeholder="Username or Org ID"
                  value={loginId}
                  onChange={(e) => setLoginId(e.target.value)}
                  autoFocus
                />
                <div className="login-hint" style={{ margin: "-10px 0 10px 2px", fontSize: "0.98em", color: "#907dd0", opacity: 0.89 }}>
                  Use <b>Username</b> or <b>Organization ID</b>
                </div>
                {/* Password input */}
                <div className="password-input-wrap">
                  <input
                    className="login-input"
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="toggle-password-btn"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex={-1}
                  >
                    {showPassword ? (
                      <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
                        <path
                          d="M1 12C3.5 6.5 8 3 12 3C16 3 20.5 6.5 23 12C20.5 17.5 16 21 12 21C8 21 3.5 17.5 1 12Z"
                          stroke="#444"
                          strokeWidth="1.7"
                        />
                        <circle cx="12" cy="12" r="3.5" stroke="#444" strokeWidth="1.7" />
                      </svg>
                    ) : (
                      <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
                        <path
                          d="M1 12C3.5 6.5 8 3 12 3C16 3 20.5 6.5 23 12C20.5 17.5 16 21 12 21C8 21 3.5 17.5 1 12Z"
                          stroke="#888"
                          strokeWidth="1.7"
                        />
                        <line
                          x1="3"
                          y1="21"
                          x2="21"
                          y2="3"
                          stroke="#888"
                          strokeWidth="1.4"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                {/* Submit button */}
                <button className="login-btn" type="submit">
                  Login
                </button>
              </form>
              {/* ERROR */}
              {error && <p className="login-error">{error}</p>}
            </div>
          </section>
        </div>
        {/* SWITCH TO EMPLOYEE LOGIN */}
        <button
          className="switch-to-employee"
          onClick={() => navigate("/login")}
        >
          ← Go to Employee Login
        </button>
      </div>
    </>
  );
}
